var _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckboxDisactiveDisabledIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 9,
    height: 9,
    rx: 1.5,
    fill: "#DFEAEB",
    stroke: "#B8C6C7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxDisactiveDisabledIcon);
export default __webpack_public_path__ + "static/media/CheckboxDisactiveDisabledIcon.fbd8642cda53065a7cda7e95300a1869.svg";
export { ForwardRef as ReactComponent };